export default __webpack_public_path__ + "static/media/13.e8cf74b6.png";